module.exports = __webpack_public_path__ + "static/img/sy_sj_ct.c88dc5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sy_sj_ct.png
// module id = +N0L
// module chunks = 1